import Heading from "@/components/heading"
import { ILogo, LogoWall } from "@/components/logo-wall"
import { Spacer } from "@/components/spacer"
import { Testimonials, TestimonialsProps } from "@/sections/testimonials"
import React, { FC } from "react"
import { up } from "styled-breakpoints"
import styled from "styled-components"

interface ICustomers {
  logos: Array<ILogo>
  testimonials?: TestimonialsProps["data"]
  title: string
}

export interface CustomersProps {
  className?: string
  data?: ICustomers
}

const Wrapper = styled.div<CustomersProps>`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: 0 auto;

  ${up("lg")} {
    gap: 16px 80px;
    max-width: 1240px;
    padding: 36px 16px;
  }
`

export const Customers: FC<CustomersProps> = (props) => {
  const { className, data } = props

  if (!data) return null

  const { logos, testimonials, title } = data

  return (
    <Wrapper className={className && className !== "" ? className : ""}>
      <Heading center size="h3" title={title} titleTag="h2" whiteGradient />
      <Spacer height={{ default: "40px", lg: "0" }} />
      <LogoWall data={logos} />
      <Spacer height={{ default: "20px", md: "0" }} />
      <Testimonials data={testimonials} />
    </Wrapper>
  )
}
